import React from 'react';
import { Bar } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { analyticsChartTheme } from 'util/chartUtils';
import CardBox from '../../../../components/kea/CardBox';
import DashboardStub from '../../../../components/kea/DashboardStub';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

function AdditionalProfit({ money }) {
  const t = useLocalizedMessage();
  const { currencyId } = useSelector((store) => store.settings, undefined);

  const chartOptions = {
    legend: {
      display: false,
      position: 'bottom',
    },
    tooltips: {
      mode: 'index',
      intersect: false,
    },
    scales: {
      xAxes: [{
        stacked: true,
      }],
      yAxes: [{
        stacked: true,
        ticks: {
          beginAtZero: true,
        },
      }],
    },
  };

  function prepareData(data) {
    return {
      labels: [t('recs.dashboard.additionalProfit.withoutRecs'), t('recs.dashboard.additionalProfit.withRecs')],
      datasets: [
        {
          label: t('ui.recs.dashboard.additionalProfit.otherPurchases'),
          backgroundColor: analyticsChartTheme.grid,
          data: [data.noRecs, data.noRecsDelta],
          categoryPercentage: 0.9,
          barPercentage: 0.9,
        }, {
          label: t('ui.recs.dashboard.additionalProfit.purchasesByTheUsersWhoUsedRecommendations'),
          backgroundColor: analyticsChartTheme.brandLight,
          data: [0, data.recsFullDelta],
          categoryPercentage: 0.9,
          barPercentage: 0.9,
        }, {
          label: t('ui.recs.dashboard.additionalProfit.additionalSalesByRecommendations'),
          backgroundColor: analyticsChartTheme.brand,
          data: [0, data.recs],
          categoryPercentage: 0.9,
          barPercentage: 0.9,
        },
      ],
    };
  }

  if (money.error) {
    return (
      <CardBox header={t('recs.dashboard.additionalProfit.title')} styleName="recs-dashboard-card">
        <DashboardStub />
      </CardBox>
    );
  }
  const chartData = prepareData(money);

  return (
    <CardBox header={t('recs.dashboard.additionalProfit.title')} styleName="recs-dashboard-card">
      <div className="row">
        <div className="col-6">
          <Bar data={chartData} options={chartOptions} height={240} />
        </div>
        <div className="col-6">
          <p>{t('recs.dashboard.additionalProfit.salesShare', { rate: money.recsFullRate })}</p>
          <p>{t('recs.dashboard.additionalProfit.salesIncrease', { rate: money.totalRecPureRate })}</p>
          <p>{t('recs.dashboard.additionalProfit.additionalRevenue', { amount: money.recs, currency: currencyId })}</p>
        </div>
      </div>

    </CardBox>
  );
}

AdditionalProfit.propTypes = {
  money: PropTypes.shape({
    recs: PropTypes.any,
    noRecs: PropTypes.any,
    noRecsDelta: PropTypes.any,
    totalRecPureRate: PropTypes.any,
    recsFullRate: PropTypes.any,
    recsFullDelta: PropTypes.any,
    error: PropTypes.any,
  }).isRequired,
};

export default AdditionalProfit;
